import axios from '../../../service/index'
import React, { Component } from 'react'
import {Button, Radio, Spin} from 'antd'
import {getParams} from "../../../commponents/js/index"
import './activity.less'

class Activity extends Component {
  state = {
    userId: '',
    stuId: '',
    loading: false,
    subjectOption: [],
    ActivityList: [],
    code: '',
    authurl: ''
  }
  componentWillUnmount() {
    
  }
  componentDidMount() {
    this.subjectList()
    this.setState({loading: true})
    if(localStorage.getItem('userId')!==''&&localStorage.getItem('userId')!==null){
      this.setState({userId: localStorage.getItem('userId')},() => {
        this.InitHandle()
      })
    }else if(!(window.location.search&&getParams(window.location.search).code)) {
      this.linkAuth()
    }else{
      this.getUserInfo()
    }
  }
  linkAuth() { // 重定向授权
    axios.get('wxAuth/api/authurl').then(res => {
      if(res.data.code === '200'){
        window.location.href = res.data.data
      }
    })
  }
  getUserInfo() { // 获取信息
    axios.get(`wxAuth/api/getUserInfo/${getParams(window.location.search).code}`).then(res => {
      if(res.data.code ==='200'){
      let data = res.data.data
      this.setState({userId: data.userId },() => {
        localStorage.setItem('userId', data.userId)
        this.InitHandle()
      })
    }else{
      localStorage.clear()
      this.linkAuth()
    }
    })
  }
  codeusid() {
    axios.get(`getUserInfo/${this.state.code}`).then(res => {
      console.log(res.data.data)
    })
  }
  subjectList() {
    axios.post('list').then(res => {
      if(res.data.code === '200'){
        this.setState({subjectOption: res.data.data})
      }
    })
  }
  InitHandle() {
    this.setState({loading: false})
    axios.post('activityxet/list',{activityName: '',stuId: this.state.stuId}).then(res => {
      if(res.data.code === '200'){
        this.setState({ActivityList: res.data.data.list})
      }
    })
  }
  radioChange(e) {
    this.setState({stuId: e.target.value},() => {
      this.InitHandle()
    })
  }
  render() {
    let {subjectOption, loading, stuId, ActivityList, userId} = this.state
    return (
      <div className="activity">
        <Spin spinning={loading}>
        <div className="search">
          <Button icon="search" onClick={() => {this.props.history.push('/search',{userId})}} className="search-btn">搜索海报</Button>
        </div>
        <Radio.Group value={stuId} onChange={(e) => {this.radioChange(e)}} className="subject-name">
          <Radio.Button value="">全部</Radio.Button>
          {
            subjectOption.map(v => {
              return (<Radio.Button key={v.id} value={v.id}>{v.name}</Radio.Button>)
            })
          }
        </Radio.Group>
        <div className="line"></div>
        <ul className="content">
          {ActivityList.map((item, i) => {
            return (
              <li key={item.id}>
                <img src={item.activityCover} alt="" />
                <div className="rig">
                  <h4>{item.activityName}</h4>
                  <p>{item.activityStart}-{item.activityEnd}</p>
                  <div className="bot">
                    <span className="tip">{new Date((item.activityEnd).replace(/-/g,'/')).getTime()>new Date().getTime()?'直播':'录播'}</span>
                    <span className="bot-btn" onClick={() => {this.props.history.push('/savimg',{id: item.id, userId})}}>生成海报</span>
                  </div>
                </div>
              </li>
            )
          })}
        </ul>
        </Spin>
      </div>
    )
  }
}
export default Activity